import {
  BulletedListPlugin,
  ListItemContentPlugin,
  ListItemPlugin,
  ListPlugin,
  NumberedListPlugin,
} from '@platejs/list-classic/react'

import {
  BulletedListElement,
  ListItemContentElement,
  ListItemElement,
  NumberedListElement,
} from './ListElements'

const RichTextFieldBulletedListPlugin =
  BulletedListPlugin.withComponent(BulletedListElement)
const RichTextFieldNumberedListPlugin =
  NumberedListPlugin.withComponent(NumberedListElement)
const RichTextFieldListItemPlugin =
  ListItemPlugin.withComponent(ListItemElement)
const RichTextFieldListItemContentPlugin = ListItemContentPlugin.withComponent(
  ListItemContentElement,
)

const RichTextFieldListPlugin = ListPlugin.extend({
  plugins: [
    RichTextFieldBulletedListPlugin,
    RichTextFieldNumberedListPlugin,
    RichTextFieldListItemPlugin,
    RichTextFieldListItemContentPlugin,
  ],
})

const RichTextFieldListKit = [RichTextFieldListPlugin]

export {
  BulletedListElement,
  ListItemContentElement,
  ListItemElement,
  NumberedListElement,
} from './ListElements'
export {
  BulletedListToolbarButton,
  NumberedListToolbarButton,
} from './ListToolbarButtons'
export type { ListToolbarButtonProps } from './ListToolbarButtons'
export {
  RichTextFieldBulletedListPlugin,
  RichTextFieldListItemContentPlugin,
  RichTextFieldListItemPlugin,
  RichTextFieldListKit,
  RichTextFieldListPlugin,
  RichTextFieldNumberedListPlugin,
}
